module.exports = __webpack_public_path__ + "static/media/55.72286d33.jpg";